import moment from "moment";

export function getDevExtremeDateFormat() {
	return "dd/MM/yyyy";
}

export const getDebugPanelFormat = (date: moment.Moment) => {
	return date.format("DD/MM/yyyy");
};

export const getUserAnswerSheetSelectorFormat = (date: moment.Moment) => {
	return moment(date).format("DD MMMM YYYY hh:mm");	
};

export enum DateTimeSeparator {
	AT = "at",
	COMMA = ", ",
}

export function formatDate(date: moment.Moment, dateTimeSeparator: DateTimeSeparator = DateTimeSeparator.COMMA): string {
	return `${formatDateOnly(date)} ${dateTimeSeparator} ${formatTime(date)}`;
}

export const formatDateOnly = (date: moment.Moment): string => {
	if (date) {
		return date.format("MMMM D, YYYY");
	}
	return "";
};

export function formatTime(time: moment.Moment): string {
	if (time) {
		return time.format("h:mm A");
	}
	return "";
}
